// extracted by mini-css-extract-plugin
export var actionButton = "_jx-0";
export var fileInput = "_jx-2";
export var paperclip = "_jx-1";